
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["loyalty-preview-main__preview",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 367 614"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"367","height":"614","fill":"#EBEFF4","rx":"35"}}),_c('rect',{attrs:{"width":"325","height":"570","x":"21","y":"22","fill":"#fff","rx":"14"}}),_c('path',{attrs:{"fill":"#EBEFF4","d":"M28 35a7 7 0 017-7h297a7 7 0 017 7v145a3 3 0 01-3 3H31a3 3 0 01-3-3V35z"}}),_c('rect',{attrs:{"width":"178","height":"31","x":"28","y":"190","fill":"#EBEFF4","rx":"3"}}),_c('rect',{attrs:{"width":"178","height":"24","x":"28","y":"340","fill":"#EBEFF4","rx":"3"}}),_c('rect',{attrs:{"width":"72","height":"72","x":"267","y":"340","fill":"#EBEFF4","rx":"3"}}),_c('rect',{attrs:{"width":"207","height":"17","x":"28","y":"371","fill":"#EBEFF4","rx":"3"}}),_c('rect',{attrs:{"width":"120","height":"17","x":"28","y":"395","fill":"#EBEFF4","rx":"3"}}),_c('rect',{attrs:{"width":"178","height":"24","x":"28","y":"426","fill":"#EBEFF4","rx":"3"}}),_c('rect',{attrs:{"width":"72","height":"72","x":"267","y":"426","fill":"#EBEFF4","rx":"3"}}),_c('rect',{attrs:{"width":"207","height":"17","x":"28","y":"457","fill":"#EBEFF4","rx":"3"}}),_c('rect',{attrs:{"width":"120","height":"17","x":"28","y":"481","fill":"#EBEFF4","rx":"3"}}),_c('rect',{attrs:{"width":"178","height":"24","x":"28","y":"512","fill":"#EBEFF4","rx":"3"}}),_c('path',{attrs:{"fill":"#EBEFF4","d":"M267 515a3 3 0 013-3h66a3 3 0 013 3v62a7 7 0 01-7 7h-62a3 3 0 01-3-3v-66z"}}),_c('rect',{attrs:{"width":"207","height":"17","x":"28","y":"543","fill":"#EBEFF4","rx":"3"}}),_c('path',{attrs:{"fill":"#EBEFF4","d":"M28 570a3 3 0 013-3h114a3 3 0 013 3v11a3 3 0 01-3 3H35a7 7 0 01-7-7v-7z"}})])
          )
        }
      }
    